var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"login",staticStyle:{"min-height":"100vh"},attrs:{"align-v":"center"}},[_c('b-col',[_c('div',{staticClass:"main-div"},[_c('div',{staticClass:"login-form"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }